import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/shared/PageHeader";
import { DataTable } from "@/components/shared/DataTable";
import { StatusPill } from "@/components/shared/StatusPill";

export default function AIActivity() {
  const [decisions, setDecisions] = useState([]);
  const [evals, setEvals] = useState([]);
  useEffect(() => {
    api.get("/ai/decisions").then((r) => setDecisions(r.data)).catch(() => {});
    api.get("/ai/evaluation").then((r) => setEvals(r.data.evaluations || [])).catch(() => {});
  }, []);
  const cols = [
    { key: "created_at", header: "When", render: (r) => new Date(r.created_at).toLocaleString() },
    { key: "actor_name", header: "Actor", render: (r) => <>{r.actor_name}{r.support_mode && <span className="ml-1 text-[10px] text-amber-600">SUPPORT</span>}</> },
    { key: "what", header: "What", render: (r) => r.action_performed ? <span className="text-emerald-700">Performed: {r.action_performed}</span> : <span className="text-slate-700">Asked: {r.request?.slice(0, 60)}</span> },
    { key: "consulted", header: "Grounded in", render: (r) => <span className="text-xs text-slate-500">{(r.records_consulted || []).length} records · {(r.knowledge_consulted || []).length} knowledge</span> },
    { key: "auth", header: "Authorization", render: (r) => <span className="text-xs text-slate-500">{r.authorization || "read"}</span> },
  ];
  return (
    <div>
      <PageHeader title="AI Activity & Evaluation" subtitle="Every Atlas decision and action — visible, grounded, and audited" />
      <h3 className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2">Evaluation — reality vs approved knowledge</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6" data-testid="ai-evaluation">
        {evals.length === 0 && <p className="text-sm text-slate-400">No evaluations available.</p>}
        {evals.map((e, i) => (
          <div key={i} className="bg-white border border-slate-200 rounded-xl p-4">
            <div className="flex items-center justify-between">
              <span className="font-medium text-sm text-slate-800">{e.knowledge}</span>
              <StatusPill value={e.result === "followed" || e.result === "enforced_by_design" ? "done" : "warning"} tone={e.result === "deviation" ? "warning" : "success"} />
            </div>
            <p className="text-sm text-slate-500 mt-1">{e.detail}</p>
            <div className="text-[10px] uppercase tracking-wide text-slate-400 mt-1">{e.result.replace(/_/g, " ")}</div>
          </div>
        ))}
      </div>
      <h3 className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2">AI decision & action ledger</h3>
      <DataTable testid="ai-decisions-table" columns={cols} rows={decisions} empty="No AI activity yet" />
    </div>
  );
}
